import momentGenerateConfig from "rc-picker/es/generate/moment";
import generateCalendar from './generateCalendar';
var Calendar = generateCalendar(momentGenerateConfig);
export default Calendar;